import type * as React from 'react';
import { useMessageHandler } from '~/Features/Messaging/useMessageHandler';
import { GtmEventsBase } from '~/Partials/GoogleTagManager/GtmEventsBase';
import { FormSubmitted } from './Events/FormSubmitted';

interface BookMeetingGtmSubscriptionProps {
    formId: string;
}

export const BookMeetingGtmSubscription: React.FC<BookMeetingGtmSubscriptionProps> = props => {
    const { formId } = props;

    useMessageHandler(FormSubmitted.getMessageId(formId), () => {
        GtmEventsBase.pushEvent('Form submitted', { type: 'Book a meeting' });
    });

    return null;
};
